export const getSidenavItemAnalyticsJson = (eventLabel) => JSON.stringify({
    applicationName: 'appheader',
    elementPath: 'appheader',
    elementType: 'sidenav navigation',
    action: 'click',
    eventLabel,
});

export default getSidenavItemAnalyticsJson;
